import { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { UIAndUXDesignServiceData } from "../../common";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import SoftwareTeamHunt from "../../components/CaseStudy/SoftwareTeamHunt";
import { getIPGeoLocation } from "../../common/GeneralUtils";
// import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import * as Icons from '../../common/icons/uIAndUXDesignServiceDataIcons';
import Toasts from "../../components/Toasts/Toasts";

// import Loadable from "../../components/Loadable"
// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )
// const SoftwareTeamHunt = Loadable(
//     lazy(() => import('../../components/CaseStudy/SoftwareTeamHunt'))
// )

const UIAndUXDesignServiceScreen = () => {
    const [toasts, setToasts] = useState(null)
    const [WebAppDevelopmentData, setData] = useState({});
    const [QualityAssuranceServiceData, setQualityAssuranceServiceData] = useState({});
    const [UIAndUXDesignServiceData, setUIAndUXDesignServiceData] = useState({});

    const getAllWebAppDevelopmentData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/webAppDevelopmentData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllQualityAssuranceServiceData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/qualityAssuranceServiceData.json');
            setQualityAssuranceServiceData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllUIAndUXDesignServiceData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/uIAndUXDesignServiceData.json');
            setUIAndUXDesignServiceData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        getIPGeoLocation();
        getAllWebAppDevelopmentData();
        getAllQualityAssuranceServiceData();
        getAllUIAndUXDesignServiceData();
    }, [])
    return (
        <Fragment>
            <Helmet>
                <title>Creative UI and UX Design Services for Web and Mobile Apps</title>
                <meta name="description" content="Discover UI and UX design services that enhance usability, boost retention, and deliver delightful digital experiences. For free quote, call now!" />
                <meta name="keywords" content="ui and ux design service" />
                <meta property="og:title" content="Creative UI and UX Design Services for Web and Mobile Apps" />
            </Helmet>
            <div id="main-wrapper">
                <Header />
                <div className="page-wrapper UI-And-UX-design-service-page-wrapper">
                    <div className="container-fluid">
                        <div className="page-content-top">
                            <AboutUsBanner bannerImg={UIAndUXDesignServiceData?.bannerImg} data={UIAndUXDesignServiceData?.headerData} />
                            <div className="content-tech-page-warper">
                                <Container>
                                    <div className="page-context-text">
                                        <h2>{UIAndUXDesignServiceData?.elevateExcellence?.title}</h2>
                                    </div>
                                </Container>
                            </div>
                            <section className="elevateExcellence">
                                <Container>
                                    <Row>
                                        <Col lg={6} md={6} sm={6} className="elevate-excellence pe-5 d-flex align-items-center justify-content-center">
                                            <div className="revolutionize-content pe-5">
                                                {UIAndUXDesignServiceData?.elevateExcellence?.paragraph?.length > 0 && QualityAssuranceServiceData?.elevateExcellence?.paragraph?.map((text, index) => <p key={index}>{text.text}</p>)}
                                            </div>
                                        </Col>
                                        <Col lg={6} md={6} sm={6}>
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    src={UIAndUXDesignServiceData?.elevateExcellence?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="GameChanger-process" >
                                <Container>
                                    <h3>{UIAndUXDesignServiceData?.GameChanger?.title}</h3>
                                    <span className="pe-5">{UIAndUXDesignServiceData?.GameChanger?.subTitle}</span>
                                    <div className="core-mobile-app-card pt-5">
                                        <Row>
                                            <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                                                <div className="img-div-width">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        src={UIAndUXDesignServiceData?.GameChanger?.pageImg} // use normal <img> attributes as props
                                                    />
                                                </div>
                                            </Col>
                                            <Col className="content-body pe-5" lg={6} md={6} xs={12}>
                                                {UIAndUXDesignServiceData?.GameChanger?.listData?.map((chooseData, index) => {
                                                    return (
                                                        <div key={index} className="why-main-div px-5 d-flex align-items-start justify-content-start gap-3 mb-4">
                                                            <div className="why-cho0se-body">
                                                                <h4>
                                                                    {chooseData?.title}
                                                                </h4>
                                                                <p className="m-0">{chooseData?.text}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <SoftwareTeamHunt data={UIAndUXDesignServiceData?.softwareTeamHunt} />
                            <section className="core-mobile-app-section-warper">
                                <Container>
                                    <h3>{UIAndUXDesignServiceData?.OurDesignServices?.title}</h3>
                                    <h4>{UIAndUXDesignServiceData?.OurDesignServices?.subtitle}</h4>
                                    <div className="core-mobile-app-card">
                                        <Row className="m-0">
                                            {UIAndUXDesignServiceData?.OurDesignServices?.listData?.map((cardItem, index) => {
                                                return <Col key={index} md={4} lg={4} sm={1}>
                                                    <Card className="app-card">
                                                        <CardHeader>
                                                            {cardItem?.title}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <p>{cardItem?.paragraph}</p>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            })}
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className="core-mobile-app-process" >
                                <Container>
                                    <h3>{UIAndUXDesignServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.title}</h3>
                                    <h4 className="pe-5">{UIAndUXDesignServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.subTitle}</h4>
                                    <div className="core-mobile-app-card pt-5">
                                        <Row>
                                            <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                                                <div className="img-div-width">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        src={UIAndUXDesignServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.pageImg} // use normal <img> attributes as props
                                                    />
                                                </div>
                                            </Col>
                                            <Col className="content-body" lg={6} md={6} xs={12}>
                                                {UIAndUXDesignServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.listData?.map((chooseData, index) => {
                                                    const Icon = Icons[chooseData?.icon] || null;
                                                    return (
                                                        <div key={index} className="px-5 d-flex align-items-start justify-content-start gap-3">
                                                            <div className="why-choose-icon">{Icon && <Icon />}</div>
                                                            <div className="why-cho0se-body">
                                                                <h4>
                                                                    {chooseData?.title}
                                                                </h4>
                                                                <p>{chooseData?.text}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className="our-design-tools-section">
                                <Container>
                                    <Row>
                                        <Col lg={5} md={5} >
                                            <div className="cont-div-0p">
                                                <h3>{UIAndUXDesignServiceData?.OurDesignTools?.title}</h3>
                                                <p>{UIAndUXDesignServiceData?.OurDesignTools?.paragraph}</p>
                                            </div>
                                        </Col>
                                        <Col lg={7} md={7} >
                                            <Row>
                                                {UIAndUXDesignServiceData?.OurDesignTools?.toolList?.map((tool, index) => {
                                                    return (
                                                        <Col lg={6} md={6} >
                                                            <Card key={index} className="assurance-warper-card">
                                                                <CardBody>
                                                                    <p className="eee">{tool?.title}</p>
                                                                    <div className="d-flex align-item-center justify-content-start gap-3 flex-wrap">
                                                                        {tool?.tools?.map((para, index) => {
                                                                            return (
                                                                                <Button key={index}>{para?.title}</Button>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className='Tech-Industry-Quality'>
                                <div className='tech-content py-5' style={{ backgroundImage: `url(${UIAndUXDesignServiceData?.TurningIdeas?.bgImg})` }}>
                                    <div className="bg-color-rgba">
                                        <Container className="py-4 ps-5">
                                            <Row className="justify-content-end">
                                                <Col lg="7" md="7" className="align-self-start">
                                                    <div className='page-content'>
                                                        <h3>{UIAndUXDesignServiceData?.TurningIdeas?.title}</h3>
                                                        {UIAndUXDesignServiceData?.TurningIdeas?.paragraph?.map((para, index) => {
                                                            return (
                                                                <p key={index}>{para?.text} <Link className='text-decoration-none text-white' to={window?.location?.origin}>{para?.link}</Link> {para?.text1}</p>
                                                            )
                                                        })}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </section>
                            <CustomerReviews />
                            <div className="home-contact-page">
                                <ContactUsComponent setToasts={setToasts} />
                            </div>
                            <FrequentlyAskedQuestions faqData={WebAppDevelopmentData?.FrequentlyAskedQuestionsData} />
                        </div>
                    </div>
                </div>
                <Footer />
                {toasts && <Toasts toastsList={toasts} />}
            </div>
        </Fragment>
    );
}

UIAndUXDesignServiceScreen.propTypes = {
    classes: PropTypes.object
};

export default UIAndUXDesignServiceScreen;
